import React, { useState, useEffect } from 'react';
import { CnAsyncSelect, CnTimePickerPro } from '@sto/cn-ui';
import styles from './index.module.scss';
import { TIME_FREQUENCY, getTimeFrequency } from '@/const';

const days: any[] = [];
for (let i = 1; i <= 31; i++) {
  days.push({ label: i + '号', value: i });
};

const weeks: any[] = ['一', '二', '三', '四', '五', '六', '日'].map((item, index) => ({ label: `周${item}`, value: index + 1 }));

const timePoints: any[] = [];
for (let i = 1; i <= 24; i++) {
  const paddedHour = i.toString().padStart(2, '0');
  timePoints.push({ label: `${i}点`, value: `${paddedHour}:00:00` });
};

/**
 * 时间级联选择组件
 * @param dataSource 数据源
 * @param pickConfig 选择配置
 * @param singleTimeSelect 是否单个时间点选择
 * @returns 
 */
const SelectTimeGroup = ({ value: propsValue, onChange, readOnly = false, disabled = false, singleTimeSelect = false }) => {
  const [frequency, setFrequency] = useState<string>(TIME_FREQUENCY.DAILY);
  const [frequencyDate, setFrequencyDate] = useState<string>('');
  const [pushTime, setPushTime] = useState<string>(''); // 单个时间点，第一版的推送时间点配置
  const [pushTimeList, setPushTimeList] = useState<string[]>([]);

  useEffect(() => {
    if (propsValue) {
      const { frequency, frequencyDate, pushTime, pushTimeList } = propsValue;
      setFrequency(frequency || TIME_FREQUENCY.DAILY);
      setFrequencyDate(frequencyDate || '');
      setPushTime(pushTime || '');
      setPushTimeList(pushTimeList || []);
    }
  }, [propsValue]);

  /**
   * 时间类型改变
   * @param val 时间类型
   */
  const onTimeTypeChange = (val) => {
    onChange({ frequency: val, frequencyDate: '', pushTime: '', pushTimeList: [] });
  };  

  /**
   * 天数改变
   * @param val 数据
   */
  const onTriggerData = (val) => {
    onChange({ frequency, frequencyDate: val, pushTime: '', pushTimeList: [] });
  };

  /**
   * 时间改变
   * @param val 时间
   */
  const onTriggerTime = (val) => {
    onChange({ frequency, frequencyDate, pushTime: val, pushTimeList });
  };

  /**
   * 多选时间点改变
   * @param val 时间点
   */
  const onTriggerTimeList = (val) => {
    onChange({ frequency, frequencyDate, pushTime, pushTimeList: val });
  };

  const renderTimeSelect = () => {
    if (singleTimeSelect) {
      // 时间选择器：换成下拉选择时间点
      return (
        <CnTimePickerPro 
          value={pushTime} 
          onChange={onTriggerTime} 
          format="HH:mm" 
          outputFormat="HH:mm:ss" 
          readOnly={readOnly} 
          disabled={disabled} 
        />
      );
    } else {
      // 多选时间点
      return (
        <CnAsyncSelect
          value={pushTimeList}
          dataSource={timePoints}
          onChange={onTriggerTimeList}
          readOnly={readOnly}
          disabled={disabled}
          mode="multiple"
          style={{ width: '200px' }}
        />
      );
    }
  };

  return (<div className={styles.selectTimeGroupBox}>
    <CnAsyncSelect
      value={frequency}
      onChange={onTimeTypeChange}
      dataSource={getTimeFrequency}
      readOnly={readOnly}
      disabled={disabled}
    />
    {frequency !== TIME_FREQUENCY.DAILY && <CnAsyncSelect 
      value={frequencyDate} 
      dataSource={frequency === TIME_FREQUENCY.MONTHLY ? days : weeks}
      onChange={onTriggerData}
      readOnly={readOnly}
      disabled={disabled}
    />}
    {renderTimeSelect()}
  </div>);
};

export default SelectTimeGroup;